import { InvalidUrlError } from '../../../common/errors/errors';
import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { ModelType } from '../../../common/utils/GQLIdEncoder';
import { ReportDiffMapper } from '../mappers/ReportDiffMapper';
import { ReportDiff } from '../models/ReportDiff';

const REPORT_DIFF_FRAGMENT = `
state
instancesCount0 {
  high
  med
  low
  passed
}
instancesCount1 {
  high
  med
  low
  passed
}
rulesCount0 {
  high
  med
  low
  passed
}
rulesCount1 {
  high
  med
  low
  passed
}
`;

export const GET_REPORT_DIFF_QUERY = `
query (
    $nodeId: ID!,
    $reportId: ID!,
  ) {
  node(id: $nodeId) {
    ... on ReportDone {
      reportDiff(reportId: $reportId) {
        ${REPORT_DIFF_FRAGMENT}
      }
    }
  }
}
`;

export const CREATE_REPORT_DIFF_QUERY = `
mutation($reportId0: ID!, $reportId1: ID!, $forceRecreate: Boolean) {
  createReportDiff(
    input: {
      reportId0: $reportId0,
      reportId1: $reportId1,
      forceRecreate: $forceRecreate,
    }
  ) {
    reportDiff {
      ${REPORT_DIFF_FRAGMENT}
    }
  }
}
`;

export class ReportDiffRepository extends BaseGQLService {
  private readonly mapper = new ReportDiffMapper();

  async getReportDiff(currentReportId: number, selectedReportId: number): Promise<ReportDiff | null> {
    return this.query(
      GET_REPORT_DIFF_QUERY,
      {
        nodeId: this.gqlIdEncoder.encode(ModelType.Report, currentReportId),
        reportId: this.gqlIdEncoder.encode(ModelType.Report, selectedReportId),
      },
      (data) => {
        if (!data.node) {
          throw new InvalidUrlError(`Invalid request: could not find Report ${currentReportId}`);
        }
        if (data.node.reportDiff === null) {
          return null;
        }
        return this.mapper.mapGQLModel(data.node.reportDiff);
      }
    );
  }

  async createReportDiff(currentReportId: number, selectedReportId: number, forceRecreate = false): Promise<ReportDiff | null> {
    return this.query(
      CREATE_REPORT_DIFF_QUERY,
      {
        reportId0: this.gqlIdEncoder.encode(ModelType.Report, currentReportId),
        reportId1: this.gqlIdEncoder.encode(ModelType.Report, selectedReportId),
        forceRecreate,
      },
      (data) => {
        if (data.createReportDiff === null) {
          return null;
        }
        return this.mapper.mapGQLModel(data.createReportDiff.reportDiff);
      }
    );
  }
}
